import Swiper, { Navigation, Lazy, Pagination, Autoplay, Thumbs } from "swiper";

const Brands = {
  init() {

    Brands.expSlider();
    Brands.mainBrands();
  },

  expSlider() {
    const expEl = $(".exp-slider");
    if (!expEl.length) {
      return;
    }

    const navPrev = expEl.find(".swiper-button--prev");
    const navNext = expEl.find(".swiper-button--next");

    if (expEl.length) {


      let thumbsSlider = new Swiper(expEl.find(".thumbs-slider")[0], {
        watchSlidesProgress: true,
        freeMode: true,
        slidesPerView: "auto",

      });

      let largeSlider = new Swiper(expEl.find(".large-slider")[0], {
        modules: [Navigation, Thumbs],
        loop: true,
        spaceBetween: 20,
        navigation: {
          prevEl: navPrev[0],
          nextEl: navNext[0],
        },
        thumbs: {
          swiper: thumbsSlider,
        }

      })
    }
  },

  mainBrands() {
    const brandsList = document.querySelector(".main-brands__list");

    if (!brandsList) return;

    const brands = brandsList.querySelectorAll(".main-brand-item");
    const brandCount = brands.length;

    if (brandCount === 3) {
      brandsList.classList.add("three-brands");
    }
  },



};

export default Brands;
